import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueActivityListPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      pages: {
        activities: {
          subtitle: "管理员发起和管理红蓝对抗演练实例，导调、裁判、复盘都围绕活动上下文展开。",
          createCompletedNotice: "已创建演练活动：{name}（{code}），列表已刷新。",
        },
      },
    },
  },
  en: {
    redblue: {
      pages: {
        activities: {
          subtitle:
            "Manage RedBlue activity instances, with director, judge, and review all scoped to the activity context.",
          createCompletedNotice: "Activity created: {name} ({code}). The list has been refreshed.",
        },
      },
    },
  },
  ja: {
    redblue: {
      pages: {
        activities: {
          subtitle:
            "演習インスタンスを管理し、ディレクター、ジャッジ、レビューはすべて活動コンテキストに従います。",
          createCompletedNotice: "演習活動を作成しました: {name} ({code})。一覧を更新しました。",
        },
      },
    },
  },
};
